import { DatetimeRange } from '@fx-ui/fine-design';
import React, { useContext } from 'react';
import { dayjsUtils, FALLBACK_REGION, get, Region } from '@libs/shared';
import { RegionContext } from '~/contexts';
import { regionUtils } from '~/utils';

type DatetimeRangeProps = React.ComponentProps<typeof DatetimeRange>;

interface RegionDatetimeRangeProps extends Omit<DatetimeRangeProps, 'format'> {
    formatType: keyof Region['dateTimeFormat'];
}

const RegionDatetimeRange: React.FC<RegionDatetimeRangeProps> = (props) => {
    const { formatType, onChange, onCalendarChange, ...otherProps } = props;

    const region = useContext(RegionContext);
    const defaultFormat = get(FALLBACK_REGION, ['dateTimeFormat', formatType]);

    return (
        <DatetimeRange
            {...otherProps}
            {...regionUtils.getDatetimeFormat({
                region,
                formatType
            })}
            // 组件库onChange和onCalendarChange第二个参数是格式化后的日期时间字符串
            // 若格式是自定义格式，则业务处可能无法正确处理
            // 因此这里统一按默认格式返回
            onChange={(dates) => {
                const start = get(dates, 0);
                const end = get(dates, 1);
                onChange?.(dates, [
                    start ? dayjsUtils.format(start, defaultFormat) : '',
                    end ? dayjsUtils.format(end, defaultFormat) : ''
                ]);
            }}
            onCalendarChange={(dates, _, info) => {
                const start = get(dates, 0);
                const end = get(dates, 1);
                onCalendarChange?.(
                    dates,
                    [
                        start ? dayjsUtils.format(start, defaultFormat) : '',
                        end ? dayjsUtils.format(end, defaultFormat) : ''
                    ],
                    info
                );
            }}
        />
    );
};

export default RegionDatetimeRange;
